import type { Field, FormResponse } from '@sine/sine-core-api-types';

import { FieldType } from '../../../services/form/constants';

type PrefilledFormValues = Record<string, FormResponse>;

export const convertArrayToObject = (array: Array<FormResponse>, key: keyof FormResponse) => {
  const obj: PrefilledFormValues = {};
  array.forEach((item) => {
    obj[item[key]] = item;
  });
  return obj;
};

export function generateInitialFormValues(fields: Array<Field> = [], prefilledForm?: Array<FormResponse>) {
  const prefilledFormReduced: Partial<PrefilledFormValues> = prefilledForm
    ? convertArrayToObject(prefilledForm, 'id')
    : {};

  const result: Record<string, string | boolean | undefined | number | { label: any; value: number | undefined }> = {};
  const filteredFields = fields.filter((field) => Object.values(FieldType).includes(field.type));

  filteredFields.forEach((curr) => {
    const field = prefilledFormReduced[curr.id];

    switch (curr.type) {
      case FieldType.MULTIPLE_CHOICE:
        result[curr.id] = field
          ? {
              label: field.value,
              value: curr.options?.findIndex((v) => v.includes(field.value)),
            }
          : undefined;
        break;
      case FieldType.SELECTIVE_CHOICE:
        result[curr.id] = field?.value || undefined;
        break;
      case FieldType.BOOLEAN_SWITCH:
        result[curr.id] = field?.value;
        break;
      case FieldType.TEXT:
      case FieldType.NUMBER:
        result[curr.id] = field?.value || '';
        break;
      case FieldType.SIGNATURE:
        result[curr.id] = field?.value || undefined;
        break;
    }
  });

  return result;
}
